export default __webpack_public_path__ + "static/media/be.7468913e.svg";